import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-white py-5 sm:py-7" data-id="element-179" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-180" data-mp="3fze45yusr5w7">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-181" data-mp="3fxuni758astw">
          WHAT NURSING PROFESSIONALS COULD SAY{' '}
          <span className="text-tech" data-id="element-182" data-mp="36ypo6yluevgo">ABOUT THIS SYSTEM</span>
        </h2>
        <p className="mt-1 text-center text-xs italic text-steel" data-id="element-183" data-mp="36wwgrh3eo77m">
          Illustrative testimonial examples only. These are not actual customer reviews. Replace
          them with verified customer feedback before publishing.
        </p>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-184" data-mp="2s28h4jkos2zx">
          {testimonials.map((testimonial, i) => <article key={testimonial.headline} className={`flex flex-col rounded-xl border border-metal bg-ice p-3 shadow-sm sm:p-4 ${i === 0 ? 'border-l-4 border-l-tech md:col-span-2' : ''}`} data-id="element-185" data-mp="v858nu4iz717" data-mpi={i}>
              <div className="flex gap-0.5" role="img" aria-label="5 out of 5 stars" data-id="element-186" data-mp="m5kjyikz0j9s">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 text-gold" fill="currentColor" strokeWidth={0} aria-hidden="true" data-id="element-187" data-mp="79bnfosgsk12" />)}
              </div>
              <h3 className="mt-1 font-display text-sm font-extrabold normal-case leading-tight tracking-normal text-navy sm:text-base" data-id="element-188" data-mp="14uhemnka5dsj">
                “{testimonial.headline}”
              </h3>
              <p className="mt-1 text-sm leading-snug text-steel" data-id="element-189" data-mp="v4o47pvvj4pv">“{testimonial.quote}”</p>
              <div className="mt-auto flex items-center gap-3 pt-2" data-id="element-190" data-mp="1iv1y7ly0rdn3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-teal font-display text-sm font-extrabold text-white" aria-hidden="true" data-id="element-191" data-mp="1nm0g2pynojsg">
                  {testimonial.name.charAt(0)}
                </span>
                <div data-id="element-192" data-mp="1sh33yucnqvvk">
                  <p className="font-display text-sm font-bold leading-none text-navy" data-id="element-193" data-mp="1ogt1hro2qnlg">
                    — {testimonial.attribution}
                  </p>
                  <p className="mt-0.5 text-xs text-steel" data-id="element-194" data-mp="1jkc3m5r2ouv6">
                    {testimonial.name}, {testimonial.age} · {testimonial.role} ·{' '}
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}